import { Suspense, useLayoutEffect, useMemo, useRef, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import gsap from 'gsap'
import './project.css'

import Nav from "../Nav/Nav"
import Sidebar from '../Sidebar/Sidebar'
import ProjectButtons from './ProjectButtons'
import Footer from '../Footer/Footer'

const Project = ({data, sidebarIsOpen, setSidebarIsOpen}) =>
{
    const id = useParams().id

    // refs
    const overlayRef = useRef()
    const titleRef = useRef()
    const subRef = useRef()

    // Assign the chosen project
    const currentProject = useMemo(()=>{
        if(id === "retail") return data[0]
        else if(id === "owners") return data[1]
        else if(id === "anila") return data[2]
        else if(id === "map") return data[3]
        else if(id === "3d-customizer") return data[4]
        else if(id === "juubix") return data[5]
        else if(id === "stockbet") return data[6]
        else if(id === "groundrock") return data[7]
    }, [])

    // Scroll to top
    useLayoutEffect(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }, [])

    useEffect(()=>{
        gsap.to(overlayRef.current, {duration:1, scaleX:0, transformOrigin: 'right', ease: "expo.in"})
        gsap.fromTo(titleRef.current, {y: 500}, {delay:1, duration:0.3, y:0, ease: "expo.out"})
        gsap.fromTo(subRef.current, {y: 500}, {delay:1.2, duration:0.3, y:0, ease: "expo.out"})
    },[])

    return(
        <div className="project">
            <div className="project-overlay" ref={overlayRef}></div>

            <Nav sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
            {sidebarIsOpen? <Sidebar /> : ""}

            <div className="project-text">
                <h1 ref={titleRef}>{currentProject? currentProject.title : ""}</h1>
                <p className='project-desc' ref={subRef}>{currentProject? currentProject.desc : ""}</p>
                {/* <p className='project-sub'>{currentProject? currentProject.sub : ""}</p> */}
                <small>Built with {currentProject? currentProject.technologies: ""}</small>
            </div>

            <Suspense fallback={<p>Loading</p>}>
                <div className="project-video-wrapper">
                    <video src={require(`../../assets/projects/${id}/video.mp4`)} autoPlay={true} loop={true}></video>
                </div>
            </Suspense>

            <div className="project-img-wrapper-cover">
                <div></div>
                <img src={require(`../../assets/projects/${id}/1.jpg`)} alt="img1" />
            </div>

            <div className="project-imgs-wrapper">
                <div>
                    <img src={require(`../../assets/projects/${id}/1.jpg`)} alt="1" />
                </div>
                <div>
                    <img src={require(`../../assets/projects/${id}/2.jpg`)} alt="2" />
                </div>
                <div>
                    <img src={require(`../../assets/projects/${id}/3.jpg`)} alt="3" />
                </div>
            </div>

            <ProjectButtons />

            <Footer />
        </div>
    )
}  

export default Project